import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorSection } from 'src/components/sections/ErrorSection';
import { Button } from 'src/components/ui/button';

type NotFoundFeatureProps = {
  route: string;
  routeTitleKey: string;
};

export function NotFoundFeature({
  route,
  routeTitleKey,
}: NotFoundFeatureProps): ReactElement {
  const { t } = useTranslation('errors');

  return (
    <ErrorSection
      action={
        <Button>
          <Link to={route}>{t(routeTitleKey)}</Link>
        </Button>
      }
      code={404}
      description={t('We could not find the page')}
      title={t('Page not found')}
    />
  );
}
